import React, { type ReactNode } from 'react'
import { useFeatureFlagVariantKey } from '@posthog/react'
import { POSTHOG_FEATURE_FLAGS } from '../PostHog/flags'
import { useFeatureFlagsReady } from '../PostHog/useFeatureFlagsReady'

/** Optional injection points for unit tests — never passed in production. */
export interface DreamsRouteGateTestOverrides {
  variant?: string | boolean
  flagsReady?: boolean
}

export type DreamsRouteGateProps = {
  children: ReactNode
  notFound: ReactNode
  testOverrides?: DreamsRouteGateTestOverrides
}

/**
 * Gate for /aichat/dream on the `ai-dreams` flag. Paints nothing until the client `/flags`
 * call resolves, so SSR and hydration agree and the cohort never sees a 404 flash.
 */
function DreamsRouteGate ({ children, notFound, testOverrides }: DreamsRouteGateProps) {
  const flagVariant = useFeatureFlagVariantKey(POSTHOG_FEATURE_FLAGS.AI_DREAMS)
  const flagsReadyFromClient = useFeatureFlagsReady()
  const variant = testOverrides && 'variant' in testOverrides ? testOverrides.variant : flagVariant
  const flagsReady = testOverrides?.flagsReady ?? flagsReadyFromClient

  if (!flagsReady) {
    return null
  }
  return <>{variant === 'test' ? children : notFound}</>
}

export default DreamsRouteGate
